import React from 'react';

import styles from '../Songlist360Report.module.scss';

export const SectionTitle: React.FC<{
	sideComponent?: React.ReactElement;
}> = ({ children, sideComponent }) => {
	return (
		<div className={styles['section-title']}>
			<div className={styles['title']}>{children}</div>
			{sideComponent && (
				<div className={styles['side-component']}>{sideComponent}</div>
			)}
		</div>
	);
};
